module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 26
// module chunks = 0 1 15